'use strict'

angular.module('rmGroups', [])

require('./controller/index.js')
require('./resources/index.js')
require('./routes.js')
